import api from '@/services/api'

export default {
  async getMallCalendar (mallId, year, userId = null) {
    try {
      const res = await api.get('/malls/' + mallId + '/calendar/' + year, {params: {withUserData: userId}})
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },

  async createMallCalendar (mallId, year) {
    try {
      const res = await api.post('/malls/' + mallId + '/calendar/' + year)
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },


  async updateMallCalendar (mallId, year, calendar) {
    try {
      const res = await api.put('/malls/' + mallId + '/calendar/' + year, calendar)
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },

  async getUserClosingDates (userId, year) {
    try {
      const res = await api.get('/users/' + userId + '/calendar/' + year + '/closing_dates')
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },

  async updateUserClosingDates (userId, year, dates) {
    try {
      const res = await api.put('/users/' + userId + '/calendar/' + year + '/closing_dates', dates)
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },

  async setMallCalendarFlux (mallId, calendarDateId, fluxCount) {
    try {
      const res = await api.patch('/malls/' + mallId + '/calendar_date/' + calendarDateId + '/flux', {fluxCount})
      return res.data
    } catch (error) {
      throw `Calendar api service ${error}`
    }
  },
}